__webpack_require__.p = "/Coursia/";